import React from "react";
import Dialog from "@material-ui/core/Dialog/Dialog";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import FilterNoneIcon from '@material-ui/icons/FilterNone';
import {Divider} from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button";

const DialogWrapper = ({children, open, onClose, apply, toggleFullScreen, title}) => {
    return (
        <Dialog open={Boolean(open)} onClose={onClose} fullScreen>
            <div style={{padding: 5, display: 'flex'}}>
                <div style={{flexGrow: 1}}>
                    <Typography color={"textSecondary"}>
                        {title}
                    </Typography>
                </div>
                <Tooltip title={'Restore Down'}>
                    <IconButton onClick={toggleFullScreen} size={"small"}>
                        <FilterNoneIcon style={{fontSize: '1rem'}}/>
                    </IconButton>
                </Tooltip>
                <Tooltip title={'Close'}>
                    <IconButton onClick={onClose} size={"small"}>
                        <CloseIcon style={{fontSize: '1rem'}}/>
                    </IconButton>
                </Tooltip>
            </div>
            <Divider/>
            <DialogContent style={{padding: 0}}>
                {children}
            </DialogContent>
            <Divider/>
            <DialogActions style={{padding: 0}}>
                <div style={{padding: 5, textAlign: "right"}}>
                    <Button
                        size={"small"}
                        variant={"contained"}
                        color={"primary"}
                        onClick={() => {
                            apply();
                            onClose();
                            toggleFullScreen()
                        }}
                    >
                        Apply
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    )
};
export default DialogWrapper